'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (isAdmin, handlers) {
  return function (store) {
    var client = null;

    var fetchWidgetClient = (0, _underscore.once)(function (sessionId, messageId) {
      var dispatch = store.dispatch;
      (0, _WidgetPubNubClient.fetchWidgetPubNubClient)({
        store: store,
        sessionId: sessionId,
        messageId: messageId,
        isRestrictedToMaxConcurrentChats: (0, _widgetDataSelectors.getIsRestrictedToMaxConcurrentChats)(store.getState())
      }).then(function (_ref) {
        var widgetClient = _ref.client,
            config = _ref.config;

        client = widgetClient;
        var channel = config.channel[_Defaults.WIDGET_CHANNEL_INDEX];
        var uuid = widgetClient.getUUID();
        dispatch((0, _ClientActions.pubNubClientConnected)(uuid));
        dispatch((0, _ConversationsActions.openConversationForNewChannel)({
          channel: channel,
          timestamp: _I18n2.default.moment().valueOf()
        }));
      }).catch(function (error) {
        if (error instanceof _errors.ExpectedPubNubError) {
          return (0, _q2.default)(error);
        }
        return _q2.default.reject(error);
      }).done();
    });

    var fetchAdminClient = function fetchAdminClient() {
      var dispatch = store.dispatch;
      (0, _AdminPubNubClient.fetchAdminPubNubClient)(store).then(function (adminClient) {
        client = adminClient;
        var uuid = adminClient.getUUID();
        dispatch((0, _ClientActions.pubNubClientConnected)(uuid));
        dispatch((0, _ConversationsActions.subscribeToOpenChannels)());
      }).done();
    };

    return function (next) {
      return function (action) {
        var state = store.getState();
        var type = action.type;


        if (shouldFetchWidgetClient(action, state)) {
          var sessionId = (0, _widgetDataSelectors.getSessionId)(state);
          var messageId = (0, _widgetDataSelectors.getMessageId)(state);
          fetchWidgetClient(sessionId, messageId);
        }

        if (type === _ActionTypes2.default.SWITCH_PUBNUB_CHANNEL && !isAdmin) {
          fetchWidgetClient();
        }

        if (shouldFetchAdminClient(action, state)) {
          fetchAdminClient();
        }

        if (type === _ActionTypes2.default.FORCE_CLIENT_OFFLINE && isClientReady(client)) {
          client.stop();
        }

        var handler = handlers[type];
        if (typeof handler === 'function' && isClientReady(client)) {
          handler(action, store.getState, store.dispatch, client, isAdmin);
        }

        return next(action);
      };
    };
  };
};

var _underscore = require('underscore');

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _AdminPubNubClient = require('conversations-core/pubNubClients/AdminPubNubClient');

var _WidgetPubNubClient = require('conversations-core/pubNubClients/WidgetPubNubClient');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _ClientActions = require('conversations-core/actions/ClientActions');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _userSelectors = require('conversations-core/selectors/userSelectors');

var _errors = require('PubNubJS/errors');

var _Defaults = require('conversations-schema/constants/Defaults');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isClientReady = function isClientReady(client) {
  return client !== null && typeof client !== 'undefined';
};
var shouldFetchAdminClient = function shouldFetchAdminClient(action, state) {
  return action.type === _ActionTypes2.default.GET_CONVERSATIONS_SUCCEEDED && (0, _clientSelectors.getIsAdmin)(state) && (0, _userSelectors.hasMessagesChatAccess)(state);
};

var shouldFetchWidgetClient = function shouldFetchWidgetClient(action, state) {
  return action.type === _ActionTypes2.default.ADD_MESSAGE_TO_CONVERSATION && !(0, _ConversationalMessageModel.isInitialMessage)(action.payload.message) && !(0, _clientSelectors.getIsAdmin)(state) && (0, _widgetDataSelectors.isResponderOnline)(state) && !(0, _clientSelectors.isPubNubConnected)(state);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/PubNubHandlerMiddleware.js
// module id = 485
// module chunks = 0